<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Authors List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Authors Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="top-bar">
      <div class="filter-user">
        <button type="button"
                class="el-button el-button--primary"
                @click="goToAddAuthor">
          <span>Add new</span>
        </button>
      </div>
      <el-input
          v-model="searchQuery"
          placeholder="Search by name"
          style="margin-bottom: 20px; width: 300px;"
      ></el-input>
    </div>
    <el-table
        ref="indexingTable"
        :data="filteredAuthors"
        style="width: 100%;"
    >
      <el-table-column label="#" type="index"></el-table-column>

      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column prop="email" label="Email">
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>

      <el-table-column prop="slug" label="Slug">
        <template slot-scope="scope">
          {{ scope.row.slug }}
        </template>
      </el-table-column>

      <el-table-column prop="title" label="Title">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="Date">
        <template slot-scope="scope">
          {{ new Date(scope.row.created_at).toLocaleString() }}
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteAuthor(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderSortTitle from "../../../../components/UsersList/HeaderSortTitle.vue";

export default {
  name: 'AuthorPage',
  components: {HeaderSortTitle},
  data () {
    return {
      searchQuery:''
    }
  },
  computed: {
    ...mapGetters({
      authors: 'authors/getAuthors',
    }),
    filteredAuthors() {
      return this.authors.filter(author =>
          author.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  created () {
    let params = '';
    if (this.countNets) {
      params = `per_page=${this.countNets}`
    }
    this.$store.dispatch('authors/getAuthors', params)
  },
  mounted () {
    this.getAuthors();
  },
  methods: {
    ...mapActions('authors', ['getAuthors']),
    deleteAuthor(params) {
      this.$store.dispatch('authors/deleteAuthor', params.id)
    },
    handleEdit(row) {
      this.$router.push({name: 'author-edit', params: {id: row.id}})
    },
    goToAddAuthor(){
      this.$router.push({name: 'author-create'})
    }
  }
}
</script>